import BRflag from "./assets/brazil.svg";
import PTflag from "./assets/portugal.svg";
import ESflag from "./assets/spain.svg";
import USflag from "./assets/united-states.svg";

/**
 * The languages this application ships, in the order they are offered.
 *
 * ORDER IS LOAD-BEARING, not cosmetic: `normalizeLocale` resolves a bare
 * language subtag against this list and takes the first match, so `pt` lands on
 * whichever Portuguese variant is declared first. pt-BR comes first because it
 * is the larger audience. Moving pt-PT above it silently rehomes every visitor
 * whose browser or host sends a plain `pt`.
 *
 * The labels name the VARIANT, not just the language. Before pt-PT existed this
 * list called Brazilian Portuguese "Português (PT)" — with both variants on
 * screen that reads as Portugal, and the visitor picking European Portuguese
 * would get the Brazilian bundle. The `(BR)`/`(PT)` pair is the whole point of
 * the selector now.
 */
export const LANGUAGES = [
    {
        code: "pt-BR",
        flag: BRflag,
        name: "Português (BR)",
    },
    {
        code: "pt-PT",
        flag: PTflag,
        name: "Português (PT)",
    },
    {
        code: "es-ES",
        flag: ESflag,
        name: "Español (ES)",
    },
    {
        code: "en-US",
        flag: USflag,
        name: "English (EN)",
    },
];
